export const state = {
  AllLinks: [
    { text: "Home", access: false, icon: "mdi-home", to: "/" },
    {
      hasChild: true,
      icon: "mdi-account-cash-outline",
      text: "Bank",
      child: [
        // {
        //   access: false,
        //   text: "New client",
        //   icon: "mdi-account-plus-outline",
        //   to: "/newCustomer"
        // },
        {
          access: false,
          text: "All Clients",
          icon: "mdi-account-group-outline",
          to: "/customers",
        },
        {
          access: false,
          text: "Transactions",
          icon: "mdi-cash-refund",
          to: "/transactions",
        },
        {
          access: false,
          text: "Debts",
          icon: "mdi-cryengine",
          to: "/debts",
        },
        {
          access: false,
          text: "Bank Summary",
          icon: "mdi-file-chart",
          to: "/BankReports",
        },
        {
          access: false,
          text: "Account Report",
          icon: "mdi-cash-multiple",
          to: "/clientCashes",
        },
      ],
    },
    {
      hasChild: true,
      icon: "mdi-transfer",
      text: "Exchange",
      child: [
        {
          access: false,
          text: "Genral Report",
          icon: "mdi-file-chart",
          to: "/exchangeReport",
        },
        {
          access: false,
          text: "USD Report",
          icon: "mdi-home-currency-usd",
          to: "/USDReport",
        },
        {
          access: false,
          text: "Inocme",
          icon: "mdi-chart-bar",
          to: "/income",
        },
      ],
    },
    {
      hasChild: true,
      icon: "mdi-home-group",
      text: "My Company",
      child: [
        {
          access: false,
          text: "Money Dep",
          icon: "mdi-cash-plus",
          to: "/cashDep",
        },
        {
          access: false,
          text: "Delete",
          icon: "mdi-delete-off",
          to: "/deletetran",
        },
        {
          access: false,
          text: "All Summary",
          icon: "mdi-file-chart",
          to: "/AllSummary",
        },
        {
          access: false,
          text: "All Cash Balance",
          icon: "mdi-cash-marker",
          to: "/AllCash",
        },
        {
          access: false,
          text: "Cash Transfer",
          icon: "mdi-bank-transfer",
          to: "/Transfer",
        },
        {
          access: false,
          text: "New Expense",
          icon: "mdi-cash-remove",
          to: "/ExpenseEntry",
        },
        {
          access: false,
          text: "Show Expenses",
          icon: "mdi-cash-refund",
          to: "/expenses",
        },
      ],
    },
    {
      hasChild: true,
      icon: "mdi-account-multiple-check",
      text: "Users",
      child: [
        {
          access: false,
          text: "Groups",
          icon: "mdi-account-group",
          to: "/groups",
        },
        {
          access: false,
          text: "User List",
          icon: "mdi-account-plus-outline",
          to: "/AddUser",
        },
        // {
        //   access: false,
        //   text: "User Report",
        //   icon: "mdi-account-search",
        //   to: "/expenses"
        // }
      ],
    },
    // { text: "New Bussines", icon: "mdi-account-tie", to: "/NewAccount" }
  ],
};
export const mutations = {};
export const actions = {};
export const getters = {
  LinksGetter(state) {
    return state.AllLinks;
  },
  GroupGetters: state => {
    return state.AllLinks.filter(link => {
      return link.text != "Users";
    });
  },
};
